import { TerraProviderKind, UiPillType } from '@src/types'
import { TerraProvider } from '../../models/settings.types'

export const getProviderPillProps = (provider: TerraProvider) => {
  if (
    provider.providerKind === TerraProviderKind.GoogleHealth &&
    !provider.active &&
    provider.connectionId === null
  ) {
    return { text: 'New', status: UiPillType.Success }
  }

  if (!provider.connectionId) {
    return
  }

  return {
    text: provider.active ? 'Active' : 'Inactive',
    status: provider.active ? UiPillType.Success : UiPillType.Alert,
  }
}
